import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { antiNukeApi } from "../http/Api";

export const getAntiNuke = createAsyncThunk(
  "AntiNuke/getAntiNuke",
  async (_, thunkAPI) => {
    const {serverId} = thunkAPI.getState().serverId;
    const response = await antiNukeApi.getAntiNuke(serverId);
    console.log("response", response);

    if (response.status === 200) {
      thunkAPI.dispatch(antiNukeSlice.actions.setAntiNuke(response));
    }
  }
);

export const getAntiNukeAdvanced = createAsyncThunk(
  "AntiNuke/getAntiNukeAdvanced",
  async (_, thunkAPI) => {
    const {serverId} = thunkAPI.getState().serverId;
    const response = await antiNukeApi.getAntiNukeAdvanced(serverId);
    console.log("response", response);

    if (response.status === 200) {
      thunkAPI.dispatch(antiNukeSlice.actions.setAntiNukeAdvanced(response));
    }
  }
);

export const getAntiNukeLogs = createAsyncThunk(
  "AntiNuke/getAntiNukeLogs",
  async (_, thunkAPI) => {
    const {serverId} = thunkAPI.getState().serverId;
    const response = await antiNukeApi.getLogs(serverId);
    console.log("response", response);

    if (response.status === 200) {
      thunkAPI.dispatch(antiNukeSlice.actions.setAntiNukeLogs(response));
    }
  }
);

const initialState = {
  antiNukeGlobalState: null,
  antiNukeAdvancedGlobalState: null,
  antiNukeLogsState: null,
};

const antiNukeSlice = createSlice({
  name: "antiNuke",
  initialState,
  reducers: {
    setAntiNuke: (state, action) => {
      state.antiNukeGlobalState = action.payload;
    },
    setAntiNukeAdvanced: (state, action) => {
      state.antiNukeAdvancedGlobalState = action.payload;
    },
    setAntiNukeLogs: (state, action) => {
      state.antiNukeLogsState = action.payload;
    },
  },
});

export const antiNuke = antiNukeSlice.reducer;
